import type { RichContent } from '~/type/product/Product'

export default function (el: { [ key: string ]: any } = {}): RichContent {
  return {
    brand: el.BRAND,
    id: el.ID,
    domain: el.DOMAIN,
  }
}
